function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 10"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 3H6v3H3v2h3v3h2V8h3V6H8V3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 10h-8V2a2.003 2.003 0 00-2-2H2a2.003 2.003 0 00-2 2v10a2.003 2.003 0 002 2h8v8a2.003 2.003 0 002 2h10a2.003 2.003 0 002-2V12a2.003 2.003 0 00-2-2zM2 2h10l.002 10H2zm20 20H12v-8a2.003 2.003 0 002-2h8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 16h8v2h-8z"
})));